export function initLanguage(lang, name, form, setForm) {
    let _form = { ...form };

    if (!_form?.translations) {
        _form.translations = {};
    }

    let translations = _form.translations[name] || {};

    _form.translations[name] = translations;

    setForm({ ..._form });
}

export function cleanTranslations(trans, defaultLanguage, alreadyPresentLanguages = []) {
    let transToApply = { ...trans };

    // keep keys if they need empty string update to be removed
    transToApply = Object.fromEntries(Object.entries(transToApply).filter(([key, value]) => value !== '' || alreadyPresentLanguages?.includes(key)));
    const langKeys = Object.keys(transToApply);

    // only default or all other languages empty => reset default in translations
    if (
        (langKeys.length === 1 && langKeys[0] === defaultLanguage) ||
        (langKeys.length > 1 &&
            Object.entries(transToApply)
                .filter(k => k[0] !== defaultLanguage)
                .every(key => key[1] === ''))
    ) {
        if (alreadyPresentLanguages?.includes(defaultLanguage)) {
            transToApply[defaultLanguage] = '';
        } else {
            delete transToApply[defaultLanguage];
        }
    }

    return transToApply;
}

export function handleTranslations(value, property, selectedLanguage, form, setForm = () => {}, defaultLanguage, alreadyPresentInTranslations = {}) {
    let _form = { ...form };
    let trans = _form[`translations`] || {};

    if (!(property in trans)) {
        trans[property] = {};
    }

    trans[property][selectedLanguage] = value;
    if (selectedLanguage === defaultLanguage) {
        _form[property] = value;
    } else {
        // need to update default on all languages changes
        // updating a language can bring the default back in the translations
        // (cleanTranslations will remove it if not needed)
        trans[property][defaultLanguage] = form[property];
    }

    trans[property] = cleanTranslations(trans[property], defaultLanguage, Object.keys(alreadyPresentInTranslations[property] || {}));

    _form[`translations`] = trans;

    setForm({ ..._form });
}
